import { getMailboxInfoFromFolderId } from 'owa-mail-mailboxinfo';
import getArchiveFolderId from 'owa-session-store/lib/utils/getArchiveFolderId';

export default function isArchiveFolder(folderId: string): boolean {
    const archiveFolderId = getArchiveFolderId(getMailboxInfoFromFolderId(folderId));
    return !!(folderId && archiveFolderId && archiveFolderId == folderId);
}
